import React from 'react';
import { styled } from '@glitz/react';
import * as style from 'Shared/Style';

type PropType = {
  min: number;
  max: number;
  value: number;
  updateValue: (selectedValue: number) => void;
  width?: number;
};

const SliderInput = styled.input({
  appearance: 'none',
  height: '2px',
  borderRadius: '1px',
  backgroundColor: style.colors.monochrome.white,
  '::-webkit-slider-thumb': {
    appearance: 'none',
    width: '4px',
    height: '4px',
    borderRadius: '8px',
    backgroundColor: style.colors.monochrome.white,
    cursor: 'pointer',
    padding: {
      y: '4px',
      x: '4px',
    },
  },
})

const Slider = ({ min, max, value, updateValue, width }: PropType) => {
  return (
    <SliderInput
      type="range"
      min={min}
      max={max}
      value={value}
      onChange={(e) => updateValue(parseFloat(e.target.value))}
      css={{
        width: width ? `${width}px` : '100%',
      }}
    />
  );
};

export default Slider;
